/**
 * @module experience/shared-experience
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

import { ChannelSegmentModel } from '@experience/shared-experience/models/channel-segment.model';

export class BrowsePlansRequestModel {
  private voucher: string;
  private requestedSkus: string[];
  private productFamilyIds: string;
  private productTypes: string[];
  private channelSegment: ChannelSegmentModel;
  private billingType: string;
  private customerSegments: string[];
  private accountSegments: string[];
  private customerId: string;
  private accountId: string;
  private cartId: string;
  private lineId: string;
  private lineNumber: number;
  private transactionTypes: string[];
  private postalCode: string;
  private storeId: string;
  private offerTypes: string[];
  private offerSubTypes: string[];
  private pageSize: string;
  private pageNumber: string;
  private isDetailRequest: boolean;
  private creditLevels: string[];
  private tacCodes: string[];
  private relationTypes: string[];
  private familyCode: string;
  private offerId: string;
  public retailPlans: boolean;
  constructor(
    customerId: string,
    accountId: string,
    billingType: string,
    creditLevel: string,
    postalCode: string,
    productType: string,
    sku?: string,
    cartId?: string,
    lineId?: string,
    lineNumber?: number,
    familyCode?: string,
    transactionTypes?: string[],
    voucher?: string
  ) {
    this.voucher = voucher;
    this.productFamilyIds = '';
    this.productTypes = ['Plan'];
    this.billingType = billingType;
    this.customerSegments = [''];
    this.accountSegments = [''];
    this.accountId = accountId || '';
    this.customerId = customerId || '';
    this.cartId = cartId || 'CARTID';
    this.accountId = accountId || '';
    this.customerId = customerId || '';
    this.lineId = lineId;
    this.lineNumber = lineNumber;
    this.postalCode = postalCode;
    this.storeId = '';
    this.offerTypes = ['Base'];
    this.offerSubTypes = ['SoftGood'];
    this.pageSize = '100';
    this.pageNumber = '';
    this.isDetailRequest = true;
    this.creditLevels = [creditLevel || 'GOOD'];
    this.tacCodes = [''];
    this.requestedSkus = [sku || ''];
    this.transactionTypes = transactionTypes || [''];
    this.relationTypes = ['COMPATIBLE'];
    this.channelSegment = new ChannelSegmentModel();
    this.familyCode = familyCode || undefined;
  }
}
